<template>
  <div class="cp-material">
    <div class="item" :class="[material === 'iphone' ? 'iphone' : material === 'mate60' ? 'mate60' : 'piying']"></div>
    <div class="desc">
      {{material === 'iphone' ? 'iPhone 15 x1' : material === 'mate60' ? '华为mate60 x1' : '端午礼盒套装x1'}}
    </div>
    <div class="action" @click="handleAddress"></div>
    <div class="rule">实物奖励将在填写地址后15个工作日内发放</div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import Close from '~/components/Close/close.vue';
import Alert from "~/components/Alert";

export default {
  name: 'material',
  components: {Close},
  props: {
    material: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isHome: false,
      isDownload: false,
      isShare: false
    }
  },
  mounted() {
  },
  methods: {
    onCopy: function (e) {
      Alert('复制成功~')
    },
    onError: function (e) {
      Alert('复制失败!')
    },
    handleClose() {
      store.commit(types.HIDE_MODAL2);
    },
    handleAddress() {
      store.commit(types.SHOW_MODAL2, {type: "address"});
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-material
    position absolute
    width 6.66rem
    height 9.62rem
    background-image url('./images/material.png')
    background-size: 6.66rem 8.92rem;
    background-repeat: no-repeat;
    background-position 0 0
    .action
      position absolute
      top 6.35rem
      left 50%
      margin-left -1.16rem
      width 2.32rem
      height 0.86rem
      background-image url('./images/write.png')
      background-size: 100% 100%;
      background-repeat: no-repeat;
    .item
      position absolute
      left 50%
      margin-left -2.045rem
      top 2.26rem
      width 4.09rem
      height 3.38rem
      background-size 100% 100%
      background-position center center
      background-repeat: no-repeat;
      &.iphone
        background-size 3.38rem 3.38rem
        background-image url('./images/iphone.png')
      &.mate60
        background-size 3.38rem 3.38rem
        background-image url('./images/mate60.png')
      &.piying
        background-image url('./images/piying.png')
    .desc
      position absolute
      top 1.55rem
      width 100%
      height 0.3rem
      font-size 0.3rem
      line-height 1
      text-align center
      color #060001
      font-weight bold
    .rule
      position absolute
      top 7.67rem
      width 100%
      height 0.24rem
      font-size 0.24rem
      line-height 1
      text-align center

@keyframes fadeIn {
  from {
    opacity 0
  }
  to {
    opacity: 1
  }
}
</style>
